import { Editor, type Editor as SlateEditor } from 'slate';

import { HIGHLIGHT_MARK } from 'src/data/markedText';

interface Options {
  markUserChanges?: boolean;
}

/**
 * Stamps text the writer inserts with the `user` mark, so it does not inherit the `recompose` mark
 * of the leaf it lands in — typing inside a changed word would otherwise paint the new letters as
 * part of the change.
 *
 * Off unless the editor asks for it: only an editor that renders improve marks has anything to
 * inherit.
 */
export const withMarkUserChanges = (editor: SlateEditor, options?: Options) => {
  if (!options?.markUserChanges) {
    return editor;
  }

  const { insertBreak, insertText } = editor;

  const markInsertionAsUser = () => {
    const marks = Editor.marks(editor) as Record<string, unknown> | null;
    if (marks && marks.mark !== HIGHLIGHT_MARK.user) {
      // Assigning `editor.marks` rather than calling `addMark`, which collapses the selection:
      // https://github.com/ianstormtaylor/slate/issues/3708
      editor.marks = { ...marks, mark: HIGHLIGHT_MARK.user };
    }
  };

  editor.insertBreak = () => {
    markInsertionAsUser();
    insertBreak();
  };

  editor.insertText = (text) => {
    markInsertionAsUser();
    insertText(text);
  };

  return editor;
};
